import { styled } from '@mui/material/styles';
import { selectClasses } from '@mui/material/Select';
import { MuiSelect } from '../../../../../modules/material';
import { SelectProps } from './index';

export interface StyledSelectProps extends Omit<SelectProps, 'options'> {
  isLabel?: boolean;
  isEndAdornment?: boolean;
}

const styledSelectOptions = {
  shouldForwardProp: (prop: string) =>
    !['isEndAdornment', 'isLabel'].includes(prop),
};

export const StyledSelect = styled(
  MuiSelect,
  styledSelectOptions,
)<StyledSelectProps>(({ isEndAdornment, isLabel }) => {
  return {
    ...(isEndAdornment && { paddingRight: '32px' }),
    [`& .${selectClasses.outlined}`]: {
      padding: isLabel ? '24px 12px 8px 14px' : '16px 12px 16px 16px',
    },
  };
});
